<script>
  import Logo from 'images/gateways/wsuenergy/logo.png'
</script>

<a href="/">
  <img src={Logo} alt={window.gettext('Washington State University Energy Program')}/>
  <h1>{window.gettext('Washington Columbia Plateau Least-Conflict Solar Siting Gateway')}</h1>
</a>

<style lang="scss">
  a {
    display: flex;
    font-family: Arial, Montserrat, sans-serif, Helvetica;
    align-items: center;
    padding-left: 14px;
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }

    img {
      height: 70px;
      margin-right: 14px;
      margin-bottom: 10px;
    }

    h1 {
      font-size: 28px;
      color: $gray-4;
      width: 450px;
    }
  }
</style>
